module.exports = __webpack_public_path__ + "static/media/firefly.702dd063.jpg";